import React from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import { AgentContextProvider } from "../contexts/AgentContext";
import AgentHeader from "./Components/AgentHeader";
import AgentSidebar from "./Components/AgentSidebar";
import AgentLogin from "./Pages/AgentLogin";
import useGeneralStore from "../store/generalStore";
import NewImpLeads from "./Pages/New/ImpLeads";
import AdditionalPage from "./Pages/New/Additional";
import BrokenPTP from "./Pages/Followups/BrokenPTP";
import PendingDisp from "./Pages/Followups/PendingDisp";
import PTPLeadsPage from "./Pages/Followups/PTPLeads";
import SettlementLeadPage from "./Pages/Followups/Settlement";
import MySettlementLeadPage from "./Pages/Followups/MySettlement";
import SettlementDispositionPage from "./Pages/Followups/SettlementDisposition";
import MyPermonance from "./Pages/MyPermonance";
import MyEarnings from "./Pages/MyEarnings";
import MyCalls from "./Pages/MyCalls";
import ProfileForm from "./Pages/Profile/ProfileForm";
import useAuthStore from "../store/authStore";
import ProtectedRoute from "./ProtectedRoute";
import BorrowerInfo from "./features/borrower-info";
import AcceptedAmount from "./Pages/Followups/AcceptedAmount";
import SettlementLetterIssued from "./Pages/Followups/SettlementLetterIssued";
import CallAudit_RedirectPage from "./Pages/CallAudit_PageAssignment/CallAudit_RedirectPage";
import AgentSidebarCallAudit from "./Pages/CallAudit_PageAssignment/AgentCallAuditSidebar";
import IntroductionRouter from "./Pages/IntroductionSteps/IntroductionRouter";
import IntroThankyou from "./Pages/IntroThankyou";

export default function AgentRoutes() {
  const isSidebarOpen = useGeneralStore((state) => state.is_sidebar_open);
  const profileCompleted = useAuthStore((state) => state.profileCompleted);
  const call_audited = useAuthStore((state) => state.call_audited);
  const location = useLocation();
  const isIntroductionPage = location.pathname.includes("/agent/introduction");
  const userData = useAuthStore((state) => state.userData);


  const getBackgroundStyle = (watermarkText) => {
    const text = watermarkText || '';

    const svg = `
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 335 180">
        <text 
          x="50%" 
          y="50%" 
          font-size="70" 
          font-weight="900"
          fill="rgba(85, 85, 85, 0.08)" 
          text-anchor="middle" 
          dominant-baseline="central"
          transform="rotate(-25, 200, 90)"
        >
          ${text}
        </text>
      </svg>
    `;

    const encodedSvg = encodeURIComponent(svg);
    const bgImage = `url('data:image/svg+xml;utf8,${encodedSvg}')`;

    return {
      backgroundColor: '#f0f2f5',
      backgroundImage: `${bgImage}, ${bgImage}`,
      backgroundRepeat: 'repeat, repeat',
      backgroundPosition: '0 0, 70px 50px',
      backgroundSize: '400px 180px, 400px 180px',
    };
  };
  const backgroundStyle = getBackgroundStyle(userData?.code_4);

  return (
    <AgentContextProvider>
      {/* Login route */}
      <Route exact path="/login" component={AgentLogin} />

      {/* Profile not completed */}
      {!profileCompleted && (
        <>
          <ProtectedRoute exact path="/agent/profile/update" component={ProfileForm} />
          <Route exact path="*">
            <Redirect to="/agent/profile/update" />
          </Route>
        </>
      )}

      {/* Profile completed but not audited */}
      {!!profileCompleted && !call_audited && (
        <>
          {!isIntroductionPage && (
            <aside
              className={`${isSidebarOpen ? "sidebar" : "sidebar sidebar-hide"}`}
              style={{ width: isSidebarOpen ? "200px" : "63px" }}
            >
              <AgentSidebarCallAudit />
            </aside>
          )}
          <section className={`${!isIntroductionPage && isSidebarOpen ? "content" : "content content-full"}`}>
            {!isIntroductionPage && <AgentHeader />}
            <div className="content-part agent-background" style={backgroundStyle}>
              <ProtectedRoute exact path="/agent/introduction" component={IntroductionRouter} />
              <ProtectedRoute exact path="/agent/introduction/completion" component={IntroThankyou} />
              <ProtectedRoute exact path="/agent/call_audited" component={CallAudit_RedirectPage} />
              <Route exact path="*">
                <Redirect to="/agent/introduction" />
              </Route>
            </div>
          </section>
        </>
      )}

      {/* Profile completed and audited */}
      {!!profileCompleted && call_audited && (
        <>
          {!isIntroductionPage && (
            <aside className={`${isSidebarOpen ? "sidebar" : "sidebar sidebar-hide"}`}>
              <AgentSidebar />
            </aside>
          )}
          <section className={`${!isIntroductionPage && isSidebarOpen ? "content" : "content content-full"}`}>
            {!isIntroductionPage && <AgentHeader />}
            <div className="content-part agent-background" style={backgroundStyle}>
              {/* NEW Imp Leads */}
              <ProtectedRoute exact path="/agent/calls/new/imp-leads" component={NewImpLeads} />

              {/* Additional */}
              <ProtectedRoute exact path="/agent/calls/new/additional" component={AdditionalPage} />

              {/* Broken PTP */}
              <ProtectedRoute exact path="/agent/calls/new/broken-ptp" component={BrokenPTP} />

              {/* Pending DISP */}
              <ProtectedRoute exact path="/agent/calls/new/pending-disp" component={PendingDisp} />

              {/* PTP Leads */}
              <ProtectedRoute exact path="/agent/calls/new/ptp-leads" component={PTPLeadsPage} />

              {/*My Settle Leads Page*/}
              <ProtectedRoute exact path="/agent/calls/my-settlement-leads" component={MySettlementLeadPage} />

              {/*Settle Disposition Leads Page*/}
              <ProtectedRoute
                exact
                path="/agent/calls/settlement-disposition"
                component={SettlementDispositionPage}
              />

              {/*Settlement Letter Issued*/}
              <ProtectedRoute
                exact
                path="/agent/calls/settlement-letter-issued"
                component={SettlementLetterIssued}
              />

              {/*Settlement Accepted Amount*/}
              <ProtectedRoute
                exact
                path="/agent/calls/settlement-accepted-amount"
                component={AcceptedAmount}
              />

              {/* My Perfomance */}
              <ProtectedRoute exact path="/agent/my-perfomance" component={MyPermonance} />

              {/*My Earnings*/}
              <ProtectedRoute exact path="/agent/my-earnings" component={MyEarnings} />

              {/*My Calls*/}
              <ProtectedRoute exact path="/agent/my-calls" component={MyCalls} />

              {/* redirect if none of the above route exists */}
              <Route exact path="*">
                <Redirect to="/agent/calls/new/pending-disp" />
              </Route>

              {/* Other contents */}
              <BorrowerInfo />
            </div>
          </section>
        </>
      )}
    </AgentContextProvider>
  );
}
